/**
 * Fixed measures of the workflow scene, in px. The scene is full-bleed; these
 * are the only widths that do not flex.
 */
export const sceneMeasures = {
  /** One-row scene header. */
  headerHeight: 48,
  /** Work-item rail on `expanded` and `wide`. */
  railWidth: 260,
  /** Work-item rail on `medium`. */
  railWidthMedium: 240,
  /** Thread list beside the message pane on `expanded` and up. */
  threadListWidth: 240,
  /** Timeline filter rail inside the scene. */
  filterRailWidth: 240,
  /** Panel content column on `wide`. The region stays full-bleed. */
  contentMaxWidth: 960,
} as const;
